
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleTokenRefresh } from '../src/APIclient'
import { logoutFromAllTabs } from './utils/authSync';
 
const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('jwtToken') || sessionStorage.getItem('jwtToken');
    const expirationTime = localStorage.getItem('expirationTime') || sessionStorage.getItem('expirationTime');

    if (!token || Date.now() > expirationTime) {
      handleTokenRefresh().then(() => {
        const refreshedToken = localStorage.getItem('jwtToken') || sessionStorage.getItem('jwtToken');
        if (!refreshedToken) {
          logoutFromAllTabs();
        }
      });
    }
  }, [navigate]);

  return children;
};

export default ProtectedRoute;

